module.exports = __webpack_public_path__ + "static/media/background_top_left_clean.fd79fd4e.png";